<template>
  <layout-default>
    <div class="container account-page">
      <div class="container my-account-page d-flex flex-column">
        <div class="my-account-page-location mt-2">
          <div class="my-account-breadcrumb border-bottom">
            <Breadcrumb />
          </div>
        </div>
        <div class="my-account d-flex justify-content-center flex-wrap">
          <div class="w-75 my-account-login">
            <section class="container mb-5 terms">
              <card class="mx-auto">
                <template v-slot:title>
                  <b>Detalles del usuario</b>
                </template>
                <template v-slot:body>
                  <user-show :user="user" />
                </template>
                <template v-slot:footer>
                  <ButtonFilled
                    class="blog-btn fw-bolder"
                    :hasRoundedCorners="true"
                    :text="'Editar'"
                    size="small"
                    :location="`/admin/users/edit/${this.id}`"
                  />
                </template>
              </card>
            </section>
          </div>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import axios from "axios";
import Card from "@/components/molecules/Card/Card.vue";
import UserShow from "@/components/custom/user/show.vue";
import ButtonFilled from "@/components/atoms/Button/ButtonFilled.vue";
import Breadcrumb from "@/components/atoms/Breadcrumb/Breadcrumb.vue";
import LayoutDefault from "@/components/organisms/LayoutDefault/LayoutDefault.vue";
export default {
  name: "Profile",
  middleware: ["auth", "admin"],
  components: { LayoutDefault, Breadcrumb, Card, ButtonFilled, UserShow },
  beforeCreate() {
    document.title = "Detalles del usuario";
  },
  created() {
    this.$store.commit("setLocation", [
      {
        title: "Usuarios",
        location: `/admin/users`,
      },
      {
        title: "Detalles del usuario",
        location: `/admin/users/show/${this.id}`,
      },
    ]);
    this.fetchUser();
  },
  methods: {
    async fetchUser() {
      try {
        let loader = this.$loading.show();
        const { data } = (await axios.get(`/api/users/${this.id}`)).data;
        this.user = data;
        loader.hide();
      } catch (e) {
        return e;
      }
    },
  },
  data() {
    return {
      // Data User
      id: this.$route.params.id,
      user: { id: 0, attributes: {}, relationships: {} },
    };
  },
};
</script>

<style scoped="scoped">
.account-page {
  padding-bottom: 30px;
}
.my-account-login,
.my-account-register {
  padding: 50px 0;
}
.my-account-login {
  padding-right: 50px;
}
.my-account-register {
  padding-left: 50px;
}
.my-account-breadcrumb {
  padding-top: 20px;
  padding-bottom: 20px;
}
.my-account-title {
  font-weight: 600;
}
@media screen and (max-width: 768px) {
  .my-account {
    display: block !important;
  }
  .my-account-breadcrumb {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .account-page {
    padding: 0px !important;
    display: flex !important;
    flex-direction: column !important;
  }
  .login-input {
    width: 270px !important;
  }
  .my-account-breadcrumb {
    width: 350px;
  }
  .col-md-6 {
    padding: 35px 0px 0px 0px;
  }
  .my-account-register {
    padding-bottom: 70px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .account-page {
    padding: 50px 10px !important;
  }
  :deep(.my-account > .my-account-register .my-account-login) {
    padding: 0 !important;
  }
  .my-account {
    justify-content: space-between !important;
  }

  .my-account-page,
  .my-account {
    padding: 0px !important;
  }
}
</style>
